<section class="sec-no-data">
    <div class="wrapper-no-data">

        @if (icon() !== '') {
            <mat-icon class="material-symbols-outlined">{{icon()}}</mat-icon>
        }

        @if (title() !== ''){
            <p class="no-data-title">{{title()}}</p>
        }

        @if (message()!== '') {
            <p class="no-data-msg">{{message()}}</p>
        }
    </div>
</section>
